// Helper zum nachladen spezifischer Scripts

jQuery.cachedScript = function (url, options) {
    options = $.extend(options || {}, {
        dataType: 'script',
        cache: true,
        url: url
    });
    return jQuery.ajax(options);
};

$(function () {
    if ($('.sgkCropImage').length > 0) {
        var cacheKey = $('#sgkMainJS').attr('src').match(/v\=.*/);
        $.cachedScript('/Scripts/sgk.uploadcrop.min.js?' + cacheKey[0]);
    }
});
